import {
  ListItem,
  Text,
  ProductThumbnail,
  QuantityBadge,
} from "@towersystems/roam-common-native";
import { StockCountLine } from "@towersystems/roam-common/lib/generated-types";
import React from "react";
import { Spacings, View } from "react-native-ui-lib";
import colors from "react-native-ui-lib/src/style/colors";

export interface StockCountListLineItemProps {
  stockCountLine: StockCountLine;
  onPress?: ({ stockCountLine }: { stockCountLine: StockCountLine }) => void;
}
const columnStyle = {
  alignItems: "center",
  width: 100,
  justifyContent: "flex-end",
} as const;

export const StockCountListLineItem = ({
  stockCountLine,
  onPress,
}: StockCountListLineItemProps) => {
  const counted = React.useMemo(() => {
    return stockCountLine?.items?.reduce((acc, item) => {
      return acc + item.counted;
    }, 0);
  }, []);

  return (
    <ListItem onPress={() => onPress?.({ stockCountLine })}>
      <View
        flex
        row
        style={{
          paddingVertical: Spacings.s4,
        }}
      >
        <View
          row
          style={{ alignItems: "center", flexBasis: "100%", flexShrink: 1 }}
        >
          <View style={{ marginRight: Spacings.s4 }}>
            <ProductThumbnail imageUrl={stockCountLine.product?.image?.name} />
          </View>

          <View style={{ flexShrink: 1 }}>
            <Text variant="heading1" numberOfLines={1} ellipsizeMode="head">
              {stockCountLine?.product?.name ?? "Unknown Product"}
            </Text>
            <Text variant="heading5" color="subdued">
              {stockCountLine?.product?.stockNumber || stockCountLine.barcode}
            </Text>
          </View>
        </View>
        <View row style={columnStyle}>
          <QuantityBadge
            quantity={stockCountLine.expected || 0}
            textStyles={{
              color: colors.Text,
            }}
            style={{
              backgroundColor: "rgb(216, 217, 219)",
            }}
          />
        </View>
        <View row style={columnStyle}>
          <QuantityBadge
            quantity={counted}
            textStyles={{
              color: colors.Text,
            }}
            style={{
              backgroundColor: "rgb(216, 217, 219)",
            }}
          />
        </View>
      </View>
    </ListItem>
  );
};
